import API from "@/api";
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ConfigState {
	loading: boolean;
	error: any;
	dataList?: null | {
		tax: {
			moneys: number[];
			feeCount: number;
			maxFeeCount: number;
			min: number;
			max: number;
			fee: number;
			tax: number;
			protocol: string;
		};
		home: {
			active: number;
			share: string;
		};
		agent: {
			applyBalance: number;
		};
		vipConfig: Record<
			string,
			{
				money: string;
				rate: string;
			}
		>;
		network: {
			name: string;
			unit: string;
			rpcUrl: string;
			chainId: number;
			contractAddress: string;
			decimal: number;
			contractDecimal: number;
		};
	};
	isRefresh: boolean;
}

const initialState: ConfigState = {
	loading: false,
	error: null,
	dataList: null,
	isRefresh: false,
};

export const getApiAppConfig = createAsyncThunk(
	"config/getApiAppConfig",
	async (params: any, { getState }) => {
		try {
			const response = await API.finances.apiAppConfig(params);
			return response;
		} catch (error) {
			console.log(error);
		}
	}
);

const configSlice = createSlice({
	name: "config",
	initialState,
	reducers: {
		setIsRefresh: (state, action: PayloadAction<boolean>) => {
			state.isRefresh = action.payload;
		},
	},
	extraReducers(builder) {
		builder.addCase(getApiAppConfig.pending, (state, action) => {
			state.loading = true;
		});
		builder.addCase(getApiAppConfig.fulfilled, (state, action) => {
			try {
				const result = action.payload as any;
				if (result?.code === 0) {
					const content = result.content;
					const data = content.data;
					state.dataList = data;
					state.loading = false;
				}
			} catch (error) {
				state.loading = false;
				console.log("---apiAppConfig--:", error);
			}
		});
		builder.addCase(getApiAppConfig.rejected, (state, action) => {
			state.loading = false;
			state.error = action.error;
		});
	},
});

export const { setIsRefresh } = configSlice.actions;
export default configSlice.reducer;
